import { render, staticRenderFns } from "./TodaysAppraisalStatusFromKitReceived.vue?vue&type=template&id=495778f0&scoped=true&"
import script from "./TodaysAppraisalStatusFromKitReceived.vue?vue&type=script&lang=js&"
export * from "./TodaysAppraisalStatusFromKitReceived.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495778f0",
  null
  
)

export default component.exports